import { render, staticRenderFns } from "./ChatEvents.vue?vue&type=template&id=4bc5a068"
import script from "./ChatEvents.vue?vue&type=script&lang=js"
export * from "./ChatEvents.vue?vue&type=script&lang=js"
import style0 from "./ChatEvents.vue?vue&type=style&index=0&id=4bc5a068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports